import { putSoilDiagResult } from '../api/requester';
import { attachFileToApplication } from '../api/s3_upload';

export async function updateSoilDiagnosisResult(applicationId, result, files) {
  await putSoilDiagResult(applicationId, result);
  const attachPromises = files.map(file => attachFileToApplication(applicationId, file));
  await Promise.all(attachPromises);
}
